import React, { useCallback } from "react";
import PropTypes from "prop-types";

import Intro from "apps/messenger/components/Connections/Prematch/Intro";
import IntroConfirmation from "apps/messenger/components/Connections/Prematch/IntroConfirmation";

import { LikedVia } from "apps/messenger/components/Connections/constants";

const PrematchPages = {
	"INTRO": "INTRO",
	"CONFIRMATION": "CONFIRMATION",
};

function getPage({ sentMessage }) {
	if (sentMessage) return PrematchPages.CONFIRMATION;

	return PrematchPages.INTRO;
}

function PrematchIntro({
	targetUser,
	likedVia,
	onClose,
	likedPhoto,
	likedEssay,
	onMessageEdit,
	draft,
	error,
	sentMessage,
	sendMessage,
	onCommentEdit,
}) {
	const onSendMessage = useCallback((...args) => {
		sendMessage(...args);
	}, [ sendMessage ]);

	const currentPage = getPage({
		sentMessage,
	});

	return (
		<React.Fragment>
			{currentPage === PrematchPages.INTRO &&
				<Intro
					likedVia={likedVia}
					onClose={onClose}
					targetUser={targetUser}
					onMessageEdit={onMessageEdit}
					onCommentEdit={onCommentEdit}
					draft={draft}
					error={error}
					sendMessage={onSendMessage}
					likedPhoto={likedPhoto}
					likedEssay={likedEssay}
				/>
			}
			{currentPage === PrematchPages.CONFIRMATION &&
				<IntroConfirmation
					onClose={onClose}
					username={targetUser.username}
					thumbs={targetUser.thumbs}
					displayname={targetUser.userinfo.displayname}
					likedVia={likedVia}
					introSent={sentMessage}
				/>
			}
		</React.Fragment>
	);
}

PrematchIntro.propTypes = {
	targetUser: PropTypes.object.isRequired,
	likedVia: PropTypes.oneOf(Object.values(LikedVia)).isRequired,
	onClose: PropTypes.func.isRequired,
	likedPhoto: PropTypes.string,
	likedEssay: PropTypes.object,
	onMessageEdit: PropTypes.func.isRequired,
	sendMessage: PropTypes.func.isRequired,
	draft: PropTypes.string.isRequired,
	error: PropTypes.string,
	sentMessage: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool,
	]),
	onCommentEdit: PropTypes.func.isRequired,
};

PrematchIntro.defaultProps = {
	likedPhoto: null,
	likedEssay: null,
	sentMessage: null,
	error: null,
};

export default PrematchIntro;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/Prematch/PrematchIntro.jsx